// extracted by mini-css-extract-plugin
module.exports = {"burgerMenuWrapper":"_2gQ10hP24ER_Mtk-yeqvfB","burgerMenu":"YbI_Jw-1DnfFKTsorrFqR","isActive":"mP_D5-gw6GBV0WitqNvfL"};